import React from 'react';
import styles from './EmergencyAgsnToolbar.module.css';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Prompt } from 'react-router-dom';
import { DISPLAY_MESSAGES } from '../../constants';
import { Button } from '../../atomicComponents';
import clsx from 'clsx';

const EmergencyAgsnToolbar = ({
  lastRefreshedDate,
  restrictNavigationDuringEditing,
  hasActiveEdits,
  contextualButtonProps,
}) => {
  return (
    <>
      <div className={styles.RgtTools}>
        <span className={styles.captionSmallBt}>
          {lastRefreshedDate
            ? `Last Refreshed: ${lastRefreshedDate.format(
                'hh:mmA [(IST)] DD MMMM YYYY',
              )}`
            : 'Last Refreshed: --:--'}
        </span>
        <div className={styles.eAgsnToolbar}>
          <div className={styles.datesSelectorBar}>
          {contextualButtonProps && (
            <Button
              className={
                contextualButtonProps.isPreviousActive
                  ? clsx(styles.previousButton, styles.selectedPrevious)
                  : styles.previousButton
              }
              onClick={contextualButtonProps.handleClick}
              disabled={contextualButtonProps.disabled}
              data-testid="contextual-button"
            >
              {contextualButtonProps.text}
            </Button>
          )}
        </div>
        </div>
        {restrictNavigationDuringEditing && (
          <Prompt
            when={hasActiveEdits}
            message={() => DISPLAY_MESSAGES.NAVIGATION_WARNING}
          />
        )}
      </div>
    </>
  );
};
EmergencyAgsnToolbar.propTypes = {
  lastRefreshedDate: PropTypes.objectOf(moment),
  restrictNavigationDuringEditing: PropTypes.bool,
  hasActiveEdits: PropTypes.bool,
  contextualButtonProps: PropTypes.shape({
    text: PropTypes.string,
    handleClick: PropTypes.func,
    isPreviousActive: PropTypes.bool,
    disabled: PropTypes.bool,
  }),
};

export default EmergencyAgsnToolbar;
